// ** React Imports
import { Fragment, useState, useEffect } from 'react'

// ** Reactstrap Imports
import { Row, Col, TabContent, TabPane, Input } from 'reactstrap'

// ** Styles
import '@styles/react/libs/flatpickr/flatpickr.scss'
import '@styles/react/pages/page-account-settings.scss'

import PaymentInfo from './PaymentInfo'
import PaymentOptionsInfo from './PaymentOptions/PaymentOptionsInfo'
import MaelanowalletInfo from './MaelanoWallet/MaelanoWalletInfo'
import styles from './PaymentInfoTabs.module.scss'
import Multiselect from '../../../components/common/MultiselectDropdown/Multiselect'
import CustomDropdown from '../../../components/common/Dropdown/CustomDropDown'
import PrimaryButton from '../../../components/common/PrimaryButton/PrimaryButton'
import AddCreditAndDebitCardModal from './MaelanoWallet/AddCreditAndDebitCardModal/AddCreditAndDebitCardModal'
import AddBankAccountModal from './MaelanoWallet/AddBankAccountModal/AddBankAccountModal'
import EasyPaisaAndJazzCashModal from './MaelanoWallet/EasyPaisaAndJazzCashModal/EasyPaisaAndJazzCashModal'
import MaelanoWalletActivity from './MaelanoWallet/MaelanoWalletActivity/MaelanoWalletActivity'
import UserTabs from '../../../components/UserPortalComponents/UserTabs/UserTabs'

const PaymentInfoTabs = () => {
  // ** States
  const tabs = ["Payment Options", "Maelano Wallet"]
  const [activeTab, setActiveTab] = useState(tabs[0])

  
  const [data, setData] = useState(null)
  const [showAddBalanceForm, setShowAddBalanceForm] = useState(false)
  const [showMaelanoActivity, setShowMaelanoActivity] = useState(false)
  const [selectedModal, setSelectedModal] = useState(null);

  const handleOptionClick = (option) => {
    setSelectedModal(option);
  };

  const closeModal = () => {
    setSelectedModal(null);
  };

  const toggleTab = tab => {
    setActiveTab(tab)
  }

  const renderTabContent = () => {
    switch (activeTab) {
      case 'Payment Options':
        return <PaymentOptionsInfo />;
      case 'Maelano Wallet':
        return <MaelanowalletInfo setShowMaelanoActivity={setShowMaelanoActivity} setShowAddBalanceForm={setShowAddBalanceForm}  />;
      default:
        return null;
    }
  };

  const ChoosePaymentMethodOptions = [
    'Credit/Debit card (Ending with 2345)',
    'Credit/Debit card (Ending with 8768)',
    'Paypal',
    'Meezan bank account(Ending with 2567)',
    'Jazzcash (Ending with 4533)',
  ]
  const AddPaymentMethodOptions = [
    'Credit/Debit card',
    'Bank Account',
    'Paypal',
    'Jazzcash/Easy Paisa',
  ]

  return (
    <Fragment>
      <Row>
        <Col xs={12}>
          {showAddBalanceForm && (
            <Row noGutters className='py-3'>

              <Col xs='12' md='1'><div className='p-md-3 cursor-pointer fw-medium' onClick={() => setShowAddBalanceForm(false)}><i className="fa fas fa-caret-left"></i> BACK</div></Col>
              <Col xs='12' md='11'>

                <div>
                  <div className='fw-bold fs-4 text-center'>Add Balance</div>
                  <Row noGutters className='justify-content-center'>

                    <Col xs='12' sm='12' md='12' lg='8' xl='6'>
                      <div className='shadow rounded p-3 mt-3'>

                        <div className='text-center mt-3 shadow py-2'>
                          <div>Your Current Balance</div>
                          <div className={`fs-5 fw-medium ${styles['text-yellow']}`}>$1500.00</div>
                        </div>
                        <div className='text-center mt-3 shadow py-2'>
                          <div>Add Amount</div>
                          <div className={`fs-5 fw-medium ${styles['text-yellow']}`}>$500.00</div>
                        </div>

                        <div className={`text-center mt-3 shadow p-3`}>
                          <div className={styles['select-amount']}>

                            <div className={styles['amount']}>$25.00</div>
                            <div className={styles['amount']}>$50.00</div>
                            <div className={styles['amount']}>$100.00</div>
                            <div className={styles['amount']}>$500.00</div>
                            <div className={styles['amount']}>$1000.00</div>
                            <div className={styles['amount']}>$1500.00</div>
                          </div>

                          <Input placeholder='Add custom amount here' className='mt-3' />
                        </div>

                        <div className='mt-3'>

                          <div className='fw-medium fs-5 my-3'>Payment Option</div>

                          <Row noGutters>
                            <Col xs='12' sm='12' md='12' lg='8' xl='6'>
                              <div>
                                <Multiselect title={'Choose payment method'} options={ChoosePaymentMethodOptions} />
                              </div>
                              <div className='px-3 py-2 rounded border mt-2 text-muted'>
                                <CustomDropdown title={'Add Payment method'} options={AddPaymentMethodOptions} onClick={handleOptionClick} />
                              </div>
                            </Col>
                          </Row>

                        </div>

                        <div className='mt-3 text-center'>

                          <PrimaryButton name={'Add to Wallet'} />

                        </div>
                      </div>
                    </Col>

                  </Row>


                </div>
              </Col>

            </Row>
          )}
          {showMaelanoActivity && (
            <MaelanoWalletActivity setShowMaelanoActivity={setShowMaelanoActivity} />
          )}
          {(!showMaelanoActivity && !showAddBalanceForm) && (<div className='mx-3'>
            <UserTabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
            {renderTabContent()}
          </div>)}

        </Col>
      </Row>

      {selectedModal === 'Jazzcash/Easy Paisa' && (
        <EasyPaisaAndJazzCashModal isOpen={!!selectedModal} setIsOpen={closeModal} />
      )}
      {selectedModal === 'Bank Account' && (
        <AddBankAccountModal isOpen={!!selectedModal} setIsOpen={closeModal} />
      )}
      {selectedModal === 'Credit/Debit card' && (
        <AddCreditAndDebitCardModal isOpen={!!selectedModal} setIsOpen={closeModal} />
      )}

    </Fragment>
  )
}

export default PaymentInfoTabs
